import request from "@/utils/request.js";

/**
 * 省市区区域接口
 * @param params
 * @returns {AxiosPromise}
 */
export function listDistricts(params) {
  return request({
    url: "/operateService/api/dictionary/listDistricts",
    method: "post",
    data: params
  });
}

/**
 * 上传图片
 * @param params
 * @returns {AxiosPromise}
 */
export function getOssKey(params) {
  return request({
    closeLoading: true,
    url: "/operateService/api/oss/object/getPolicy",
    method: "post",
    data: params
  });
}

/**
 * 根据关键字获取字典
 * @param params
 * @returns {AxiosPromise}
 */
export function getKeyMap(params = []) {
  return request({
    url: "/operateService/api/base/basicDictionary/get",
    method: "post",
    data: { key: params }
  });
}

/**
 * 活动数据埋点
 * @param params
 * @returns {AxiosPromise}
 */
export function burialPoint(params = []) {
  return request({
    closeLoading: true,
    closeAllIntercept: true,
    url: "/logTrackService/api/app/logTrack/act/save",
    method: "post",
    data: params
  });
}

/**
 * 获取轮播图详情
 * @param params
 * @returns {AxiosPromise}
 */
export function get(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgIndexPage/get",
    method: "post",
    data: params
  });
}
